// test1561
(1561 && 0);
